import { buildPropsHelper } from './helpers/props';

export default {
  Time: {
    ...buildPropsHelper(),

    mounted() {
      this.onClickAwayCallback = this.onClickAway.bind(this);

      this.initialize();
    },

    updated() {
      if (this.propsChanged()) {
        this.unregisterListeners();
        this.initialize();
      }
    },

    getProps() {
      return {
        onClickAwayEvent: this.el.dataset.onClickAway,
        inputName: this.el.dataset.inputName,
        eventTarget: this.el.dataset.eventTarget,
        onBlurEvent: this.el.dataset.onBlurEvent,
      };
    },

    initialize() {
      this.setProps();
      this.registerListeners();
      this.dispatchBlurEvent();
    },

    destroyed() {
      this.unregisterListeners();
    },

    registerListeners() {
      document.addEventListener('click', this.onClickAwayCallback);
    },

    unregisterListeners() {
      document.removeEventListener('click', this.onClickAwayCallback);
    },

    onClickAway(event) {
      const isClickInside = this.el.contains(event.target);

      if (isClickInside) return;

      if (this.onClickAwayEvent) this.pushEventTo(this.el, this.onClickAwayEvent);
    },

    dispatchBlurEvent() {
      if (this.onBlurEvent)
        if (this.eventTarget) this.pushEventTo(this.eventTarget, this.onBlurEvent, { name: this.inputName });
        else this.pushEventTo(this.el, this.onBlurEvent, { name: this.inputName });
    },
  },
};
